export const getAvailableFontWeights = (weights = []) =>
  weights.filter(({ label }) => !/\bN\/A\b/i.test(label));
